import React from 'react';
import { TableHeaderWithTooltip } from '~/modules/covenants/CovenantsDataForm/components/TableHeaderWithTooltip.tsx';
import { COLUMN_TOOLTIPS } from '~/modules/covenants/constants.tsx';

interface IDocumentsViewTableHeaderProps {
  columnKey: string;
  label: string;
}

export const DocumentsViewTableHeader: React.FC<IDocumentsViewTableHeaderProps> = ({
  columnKey,
  label,
}) => {
  return (
    <TableHeaderWithTooltip
      label={label}
      tooltip={COLUMN_TOOLTIPS[columnKey]}
      ariaLabel={`Column description for ${label}`}
    />
  );
};
